<template>
  <div class="section_wrapper">
    <slot name="section"></slot>
  </div>
</template>

<script>
import ScrollMagic from 'scrollmagic';
import { mapState } from "vuex";
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

export default {
  data() {
    return {
      sectionsController: {},
      sceneSection: {}
    };
  },
  computed: {
    ...mapState(['userAgent', 'currentPage', 'currentSection', 'controllerProgressExist']),
    isIE() {
      return this.userAgent.browser.name === 'ie';
    }
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  methods: {
    precise_round(num, decimals) {
      var t = Math.pow(10, decimals);
      return (Math.round((num * t) + (decimals > 0 ? 1 : 0) * (Math.sign(num) * (10 / Math.pow(100, decimals)))) / t).toFixed(decimals);
    },
    sectionProgressDuration() {
      return this.$el.scrollHeight;
    },
    dataLayerMethod(progress, id) {
      var previousID = this.$store.state.lastPushedSection;
      if (progress >= 0.5 && id !== previousID) {
        if (window.dataLayer) {
          window.dataLayer.push({
            'event': 'section-view',
            'patient': 'patient-' + this.$route.name.toLowerCase(),
            'section #': 'section-' + id
          });
        }
        this.$store.commit('LAST_PUSHED_SECTION', id);
      }
    },
    initActiveSection() {
      if (!this.controllerProgressExist) {
        try {
          this.$scrollmagic.attachTo(document.querySelector('body'));
        }
        catch (e) {
          console.log('error!');
        }
        this.$store.commit('SET_SCROLL_PROGRESS_CONTROLLER_STATE', true);
      }
      this.sectionsController = new ScrollMagic.Controller();
      this.sceneSection = new ScrollMagic.Scene({ triggerElement: this.$el, duration: this.sectionProgressDuration(), triggerHook: 'onEnter' })
      .on('progress', (event) => {
        let progress = this.precise_round(this.currentSection.percentage[this.id], 2);
        // if (progress === null) progress = 10;
        // if (progress > 85) {
        //   this.$store.commit('SET_SECTION_FULL_SCROLL', this.id);
        //   progress = 100.00;
        // } else {
        //   this.$store.commit('SET_SECTION_PROGRESS', { section: this.id, progress: progress });
        // }
        this.dataLayerMethod(progress, this.id);
      })
      // .addIndicators({ name: 'section-wrapper'});
      this.$nextTick(() => {
        this.sceneSection.addTo(this.sectionsController);
      });
    }
  },
  mounted() {
    setTimeout(() => {
      this.initActiveSection();
    }, 2000);
  },
  destroyed() {
    this.sectionsController = null;
    this.sceneSection.destroy();
  },
  watch: {}
};
</script>

<style lang="scss"></style>
